// extracted by mini-css-extract-plugin
export default {"container":"Menus_container__JBP0Q","title":"Menus_title__mDKyc","slider":"Menus_slider__UqI7N","menu":"Menus_menu__vcTfj","menu__link":"Menus_menu__link__dknp9"};